var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 8V12H21.3333V14.6667H17.3333V18.6667H14.6666V14.6667H10.6666V12H14.6666V8H17.3333ZM24 13.6C24 8.76 20.4666 5.33333 16 5.33333C11.5333 5.33333 7.99998 8.76 7.99998 13.6C7.99998 16.72 10.6 20.8533 16 25.7867C21.4 20.8533 24 16.72 24 13.6ZM16 2.66666C21.6 2.66666 26.6666 6.96 26.6666 13.6C26.6666 18.0267 23.1066 23.2667 16 29.3333C8.89331 23.2667 5.33331 18.0267 5.33331 13.6C5.33331 6.96 10.4 2.66666 16 2.66666Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPoint);
export default __webpack_public_path__ + "static/media/add-point.97b57ab9.svg";
export { ForwardRef as ReactComponent };